// Einheitliche Status-Bezeichnungen fuer Fahrten im gesamten Portal.
//
// Zwei Status waren fuer Disponenten kaum auseinanderzuhalten, weil sie
// sprachlich dasselbe sagten ("Akzeptiert" / "Vom Fahrer angenommen"), aber
// Verschiedenes bedeuten:
//
//   pre_accepted  Nur bei Vorbestellungen: ein Fahrer ist fest gebunden, die
//                 Fahrt laeuft aber noch nicht  →  "Zugesagt"
//   accepted      Die Fahrt laeuft jetzt, der Fahrer ist in der Anfahrt. Bei
//                 einer Sofortbestellung ist die Neuigkeit die Annahme selbst
//                 ("Akzeptiert"), bei einer Vorbestellung dagegen, dass der
//                 laengst gebundene Fahrer sie jetzt antritt ("Angetreten") —
//                 dieselbe Sprache wie der Waechter E11 ("Vorbestellung nicht
//                 angetreten") und die Cloud Functions.
//
// Die Farben bleiben in beiden Faellen die der Sofortbestellung: Farbe zeigt
// die Phase, der Text den Unterschied.

// Basis-Labels je Status – aus Sicht einer Sofortbestellung.
export const RIDE_STATUS_LABELS = {
  open: 'Angefragt',
  dispatcher_pending: 'Fahrer angefragt',
  scheduled: 'Geplant',
  pre_accepted: 'Zugesagt',
  accepted: 'Akzeptiert',
  arrived: 'Angekommen',
  in_progress: 'Zielfahrt',
  paused: 'Pausiert',
  completed: 'Abgeschlossen',
  archived: 'Archiviert',
  cancelled: 'Storniert',
  cancelled_by_driver: 'Vom Fahrer storniert',
  dispatch_exhausted: 'Nicht vermittelbar',
  payment_pending: 'Zahlung ausstehend',
  payment_abandoned: 'Zahlung abgebrochen',
};

// Sammelbezeichnungen fuer Stellen ohne Fahrtbezug (Status-Filter,
// Auswertungen): dort muss ein Eintrag beide Bestellarten abdecken.
export const RIDE_STATUS_FILTER_LABELS = {
  ...RIDE_STATUS_LABELS,
  pre_accepted: 'Zugesagt (Vorbestellung)',
  accepted: 'Akzeptiert / Angetreten',
};

// Gleiche Regel wie der "Vorbestellung"/"Sofort"-Chip in den Listen: eine
// faellig gewordene Vorbestellung (convertedToOpenRide) bleibt eine
// Vorbestellung, damit Chip und Status sich nie widersprechen.
export const isPreOrderRide = (ride) => (
  ride?.orderType === 1 || ride?.convertedToOpenRide === true
);

// Label fuer eine konkrete Fahrt. `status` optional, wenn nicht der rohe
// Fahrt-Status angezeigt wird (z. B. der abgeleitete 'dispatch_exhausted').
export const getRideStatusLabel = (ride, status = ride?.status) => {
  if (status === 'accepted' && isPreOrderRide(ride)) return 'Angetreten';
  return RIDE_STATUS_LABELS[status] || status || 'Unbekannt';
};
